import styled from 'styled-components';
import { designTokens } from '../../ui/foundation/DesignTokens';

// Main Header Container
export const NavContainer = styled.header`
  grid-area: nav;
  height: 72px;
  background: white;
  border-bottom: 1px solid ${designTokens.colors.gray[200]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  gap: 12px;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 1200px) {
    padding: 0 12px;
    gap: 8px;
  }

  @media (max-width: 900px) {
    padding: 0 8px;
    gap: 6px;
    height: 64px;
  }
`;

// Brand Section (Left)
export const BrandSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 1100px) {
    gap: 6px;
  }
`;

export const LogoPill = styled.div`
  width: 116px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 900px) {
    width: 40px;
    height: 40px;
  }
`;

export const BrandMeta = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.15;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const BrandTitle = styled.div`
  font-family: ${designTokens.fonts.heading};
  font-weight: 800;
  font-size: 0.95rem;
  letter-spacing: -0.02em;
  color: ${designTokens.colors.gray[900]};
`;

export const BrandSubtitle = styled.div`
  font-size: 0.65rem;
  color: ${designTokens.colors.gray[500]};

  @media (max-width: 1100px) {
    display: none;
  }
`;

// Header Actions Section (Right)
export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-shrink: 0;
`;

export const IconButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: ${designTokens.radius.full};
  border: 1px solid ${designTokens.colors.gray[200]};
  background: white;
  color: ${designTokens.colors.gray[700]};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: ${designTokens.shadows.sm};
  font-size: ${designTokens.fontSizes.sm};

  &:hover {
    transform: translateY(-1px);
    box-shadow: ${designTokens.shadows.md};
  }

  &:focus {
    outline: none;
    box-shadow: ${designTokens.shadows.sm}, 0 0 0 3px ${designTokens.colors.primary.ring};
    border-color: ${designTokens.colors.primary[500]};
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const HeaderProfile = styled.div`
  width: 32px;
  height: 32px;
  border-radius: ${designTokens.radius.full};
  background: ${designTokens.colors.gray[100]};
  color: ${designTokens.colors.gray[600]};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s ease;
  border: 1px solid ${designTokens.colors.gray[200]};
  flex-shrink: 0;

  &:hover {
    transform: translateY(-1px);
    background: ${designTokens.colors.gray[200]};
    color: ${designTokens.colors.gray[700]};
  }

  svg {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 900px) {
    width: 28px;
    height: 28px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

// Legacy exports for compatibility
export const AvatarButton = styled.button`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  border-radius: ${designTokens.radius.full};
  border: none;
  background: transparent;
  color: ${designTokens.colors.gray[900]};
  font-size: ${designTokens.fontSizes.xl};
  cursor: pointer;
  transition: transform 0.2s ease;
  padding: 0;

  &:hover {
    transform: translateY(-1px);
  }
`;

export const ProfileContainer = styled.div`
  padding: 1.5rem 1.1rem;
`;

export const ProfileImage = styled.img`
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
`;
